import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import {
  getCollectionInfo,
  isGender,
  replaceHeadingPlaceholders,
} from '@/utils/Catalog';
import {
  ICmsCategoriesFilters,
  ICollectionPagePattern,
} from '@/interfaces/index';
import useSWR from 'swr';
import { setCollectionInfo } from '@/store/actions/collectionInfo';

export interface ICollectionInfo {
  cmsCollectionTags: ICmsCategoriesFilters;
  cmsPagePatterns: ICollectionPagePattern[];
}

function CollectionInfo(props: ICollectionInfo) {
  const { cmsCollectionTags, cmsPagePatterns } = props;
  const genders = cmsCollectionTags?.filters?.gender;
  const dispatch = useDispatch();
  const router = useRouter();

  const [routerQuery, setRouterQuery] = useState<string>();

  const fetcher = (url: string) => {
    const f = (u: string) => fetch(u).then(r => r.json());
    return f(url);
  };

  const { data } = useSWR(
    routerQuery
      ? `/api/v1/page?path=${routerQuery}&locale=${router.locale}`
      : null,
    fetcher,
    {
      revalidateOnFocus: false,
    }
  );
  useEffect(() => {
    const handleStart = (url: string) => {
      if (url.indexOf('/collections') > -1) {
        if (url.indexOf('/collections/') > -1) {
          let urlSub = url.substring(
            url.indexOf('/collections/') + '/collections/'.length
          );
          urlSub = urlSub.split('?')[0];
          const slug = urlSub.split('/');
          let isGenderPage = false;
          if (slug && slug[0] && slug[0] !== '') {
            isGenderPage = isGender(slug[0], genders);
          }

          let path;

          if (slug && slug.length > 0) {
            if (isGenderPage) {
              path = slug.join('/');
            } else {
              path = slug[0] !== '' ? slug[0] : 'all';
            }
          }

          setRouterQuery(path);
        } else {
          setRouterQuery('all');
        }
      }
    };

    router.events.on('routeChangeStart', handleStart);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      dispatch(setCollectionInfo({}));
    };
  }, []);

  useEffect(() => {
    if (data) {
      const slug = routerQuery ? routerQuery.split('/') : [];
      if (data[0]) {
        const headingReplaced = replaceHeadingPlaceholders(
          {
            placeholdersTitle: data[0]?.fields?.title,
            placeholdersDescription: data[0]?.fields?.descriptionRich,
            placeholdersDescriptionBottom:
              data[0]?.fields?.bottomDescriptionRich,
          },
          slug,
          genders,
          cmsCollectionTags
        );

        let collectionInfo = {
          title: headingReplaced.title,
          descriptionRich: headingReplaced.descriptionRich,
          bottomDescriptionRich: headingReplaced.bottomDescriptionRich,
          slug: data[0]?.fields?.slug,
          collectionImages: {
            mobile: data[0]?.fields?.collectionImageMobile,
            desktop: data[0]?.fields?.collectionImage,
          },
        };

        dispatch(setCollectionInfo(collectionInfo));
      } else {
        const headingReplaced = getCollectionInfo(
          slug,
          cmsPagePatterns,
          genders,
          cmsCollectionTags
        );

        if (headingReplaced) {
          dispatch(setCollectionInfo(headingReplaced));
        }
      }
    }
  }, [data]);

  return null;
}

export default CollectionInfo;
